import clsx from 'clsx'

import { Icon } from '@fv/client-components'
import type { ShippingLabelSize } from '@fv/client-types'

import { ListItem } from '@/components/List'
import { ShipperTooltip } from '@/components/ShipperTooltip'
import arrayOfLength from '@/utils/arrayOfLength'

import { LabelOptionForm } from './LabelOptionForm'
import type { LabelConfig } from './labelConfig'

type Props = {
  active: boolean
  onClose: () => void
  config: LabelConfig
  defaultCount: number
  loadId: string
  pieceQuantity?: number
  setActive: (s: ShippingLabelSize) => void
  unitQuantity: number
  onSubmit?: (props: {
    count: number
    loadId: string
    size: ShippingLabelSize
    start?: number
  }) => void
}

export const LabelOption = ({
  active,
  onClose,
  config,
  defaultCount,
  loadId,
  pieceQuantity,
  setActive,
  unitQuantity,
  onSubmit,
}: Props) => {
  const cells = config.count
    ? arrayOfLength(config.count).map(i => ({ key: i, content: i + 1 }))
    : [{ key: 'label', content: config.label }]

  const isRoll = config.type === 'roll'
  const rollDecorations =
    'after:absolute before:absolute after:bg-gradient-to-b after:from-fv-gray-200 after:to-white after:bottom-[calc(-0.5rem-1px)] after:left-[-5px] after:right-[-5px] after:border mb-2 group-hover:after:border-fv-gray-600 before:border-dotted before:border before:border-red-500 before:bottom-[-0.5rem] before:left-0 before:right-0 after:rounded-full before:w-full before:rounded-full before:z-10 before:border-b-0'

  return (
    <ListItem className="cursor-pointer group">
      <div
        className="flex items-center w-full"
        onClick={() => setActive(config.size)}
      >
        <div
          className={clsx(
            'shipping-label-icon grid mr-4 relative border group-hover:border-fv-gray-600 leading-none bg-gradient-to-b from-fv-gray-200 to-white',
            isRoll && 'rounded-b-lg',
            !active
              ? 'text-[.5rem] w-12 h-16 p-[.1rem] border-fv-gray'
              : 'text-xl w-32 h-[11.33rem] p-1 border-fv-gray-600',
            config.className,
            isRoll && rollDecorations,
            isRoll &&
              !active &&
              'after:h-4 after:border-fv-gray before:h-[19%]',
            isRoll &&
              active &&
              'after:h-12 after:border-fv-gray-600 before:h-[22%]',
          )}
        >
          {cells.map(({ key, content }) => (
            <div
              className={
                'flex justify-center items-center border border-fv-red-500 border-dotted'
              }
              key={key}
            >
              {content}
            </div>
          ))}
        </div>

        {active ? (
          <LabelOptionForm
            onClose={onClose}
            defaultCount={defaultCount}
            labelConfig={config}
            loadId={loadId}
            pieceQuantity={pieceQuantity}
            unitQuantity={unitQuantity}
            onSubmit={onSubmit}
          />
        ) : (
          <ShipperTooltip label={config.tooltip}>
            <Icon icon="sticky-note" />
          </ShipperTooltip>
        )}
      </div>
    </ListItem>
  )
}
